// extracted by mini-css-extract-plugin
module.exports = {"root":"LabNotesContainer_root__1nYA-","formTitle":"LabNotesContainer_formTitle__3Uxl6","main":"LabNotesContainer_main__3Dcby","tableWrap":"LabNotesContainer_tableWrap__3TSXd"};